/* LithiumPro – prisvisning inkl./ekskl. moms (til erhvervskunder)
   Omregner viste priser (÷1,25) i produktlister, produktsider, søgning og sammenligning.
   Kurv, kurv-skuffe og betaling vises altid inkl. moms. Valget huskes i browseren. */
(function (w, d) {
  'use strict';
  var KEY = 'lp_vat', RATE = 1.25;
  var SEL = '.price, .f8pr-price, .lp-cmp-price, .lp-np-ref, .lp-np-old, .lp-save, .old-price, .lp-qty, .lp-cmptable, .lp-tilvalg, [class*="price"]';
  var SKIP = 'aside#cart, #cart, .form-cart, .template-cart, .m6pn, .lp-vat-skip, [data-lp-vat-skip], .lp-vat, .lp-vat-strip, script, style';
  var RX = /(\d{1,3}(?:\.\d{3})*|\d+)(,\d{2})?\s?kr\b/g;
  var LANG = (d.documentElement.lang || 'da').slice(0, 2);
  var I18N = {
    da: { b2b: 'Erhverv &amp; samarbejde', inc: 'Inkl. moms', ex: 'Ekskl. moms', tagInc: 'inkl. moms', tagEx: 'ekskl. moms', swap: 'skift', vat: 'Moms', incS: 'Inkl.', exS: 'Ekskl.', strip: 'Du ser priser <strong>ekskl. moms</strong> (erhverv). Kurv og betaling vises altid inkl. moms.', show: 'Vis inkl. moms', aria: 'Vis priser inkl. eller ekskl. moms', title: 'Skift mellem inkl. og ekskl. moms' },
    en: { b2b: 'Business &amp; partners', inc: 'Incl. VAT', ex: 'Excl. VAT', tagInc: 'incl. VAT', tagEx: 'excl. VAT', swap: 'switch', vat: 'VAT', incS: 'Incl.', exS: 'Excl.', strip: 'Prices are shown <strong>excl. VAT</strong> (business). Cart and checkout always show prices incl. VAT.', show: 'Show incl. VAT', aria: 'Show prices incl. or excl. VAT', title: 'Switch between incl. and excl. VAT' },
    sv: { b2b: 'Företag &amp; samarbete', inc: 'Inkl. moms', ex: 'Exkl. moms', tagInc: 'inkl. moms', tagEx: 'exkl. moms', swap: 'byt', vat: 'Moms', incS: 'Inkl.', exS: 'Exkl.', strip: 'Du ser priser <strong>exkl. moms</strong> (företag). Varukorg och kassa visas alltid inkl. moms.', show: 'Visa inkl. moms', aria: 'Visa priser inkl. eller exkl. moms', title: 'Växla mellan inkl. och exkl. moms' },
    nb: { b2b: 'Bedrift &amp; samarbeid', inc: 'Inkl. mva', ex: 'Ekskl. mva', tagInc: 'inkl. mva', tagEx: 'ekskl. mva', swap: 'bytt', vat: 'Mva', incS: 'Inkl.', exS: 'Ekskl.', strip: 'Du ser priser <strong>ekskl. mva</strong> (bedrift). Handlekurv og kasse vises alltid inkl. mva.', show: 'Vis inkl. mva', aria: 'Vis priser inkl. eller ekskl. mva', title: 'Bytt mellom inkl. og ekskl. mva' },
    de: { b2b: 'Geschäftskunden &amp; Partner', inc: 'Inkl. MwSt.', ex: 'Exkl. MwSt.', tagInc: 'inkl. MwSt.', tagEx: 'exkl. MwSt.', swap: 'wechseln', vat: 'MwSt.', incS: 'Inkl.', exS: 'Exkl.', strip: 'Preise werden <strong>exkl. MwSt.</strong> angezeigt (Geschäftskunden). Warenkorb und Kasse immer inkl. MwSt.', show: 'Inkl. MwSt. anzeigen', aria: 'Preise inkl. oder exkl. MwSt. anzeigen', title: 'Zwischen inkl. und exkl. MwSt. wechseln' }
  };
  var T = I18N[LANG] || I18N.da;
  var CUR = (w.Shopify && w.Shopify.currency && w.Shopify.currency.active) || 'DKK';
  function state() { try { return localStorage.getItem(KEY) === 'ex' ? 'ex' : 'inc'; } catch (e) { return 'inc'; } }
  function save(v) { try { localStorage.setItem(KEY, v); } catch (e) { } }
  function fmt(n) { return n.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function convert(text) {
    return text.replace(RX, function (m, int, dec) {
      var n = parseFloat(int.replace(/\./g, '') + (dec ? dec.replace(',', '.') : ''));
      if (!(n > 0)) return m;
      return fmt(Math.round(n / RATE * 100) / 100) + ' kr';
    });
  }
  function walk(root, fn) {
    var it = d.createNodeIterator(root, NodeFilter.SHOW_TEXT, null), n;
    while ((n = it.nextNode())) {
      if (!/kr\b/.test(n.nodeValue)) continue;
      var el = n.parentElement; if (!el || el.closest(SKIP)) continue;
      if (!el.closest(SEL)) continue;
      fn(n);
    }
  }
  function applyEx(root) {
    walk(root || d.body, function (n) {
      if (n.__lpVat) return;
      var out = convert(n.nodeValue);
      if (out !== n.nodeValue) { n.__lpOrig = n.nodeValue; n.nodeValue = out; n.__lpVat = true; }
    });
    d.querySelectorAll('small.lp-tax').forEach(function (s) { if (!s.closest(SKIP) && s.textContent !== T.ex) { s.textContent = T.ex; } });
  }
  function revert() {
    var it = d.createNodeIterator(d.body, NodeFilter.SHOW_TEXT, null), n;
    while ((n = it.nextNode())) { if (n.__lpVat && n.__lpOrig != null) { n.nodeValue = n.__lpOrig; n.__lpVat = false; } }
    d.querySelectorAll('small.lp-tax').forEach(function (s) { if (s.textContent !== T.inc) s.textContent = T.inc; });
  }
  /* ---- UI ---- */
  function el(html) { var t = d.createElement('template'); t.innerHTML = html.trim(); return t.content.firstChild; }
  function toggleHtml(cls) {
    return '<span class="lp-vat ' + (cls || '') + '" role="group" aria-label="' + T.aria + '">' +
      '<button type="button" class="lp-vat__b" data-v="inc">' + T.inc + '</button>' +
      '<button type="button" class="lp-vat__b" data-v="ex">' + T.ex + '</button></span>';
  }
  function strip() {
    var s = d.querySelector('.lp-vat-strip');
    if (state() === 'ex') {
      if (!s) {
        s = el('<div class="lp-vat-strip" role="status"><span>' + T.strip + '</span><button type="button" class="lp-vat-strip__b" data-v="inc">' + T.show + '</button></div>');
        var c = d.getElementById('content'); if (c) c.insertBefore(s, c.firstChild);
      }
    } else if (s) s.remove();
  }
  function paintButtons() {
    var v = state();
    d.querySelectorAll('.lp-vat__b').forEach(function (b) { var p = b.getAttribute('data-v') === v ? 'true' : 'false'; if (b.getAttribute('aria-pressed') !== p) b.setAttribute('aria-pressed', p); });
  }
  function paint() {
    var v = state();
    d.documentElement.classList.toggle('lp-vat-ex', v === 'ex');
    paintButtons();
    d.querySelectorAll('.lp-vat-tag').forEach(function (t) { var want = v === 'ex' ? T.tagEx : T.tagInc; if (t.textContent !== want) t.textContent = want; });
    strip();
  }
  function set(v) {
    if (v === state()) return;
    save(v);
    if (v === 'ex') applyEx(); else revert();
    paint();
  }
  function mountUI() {
    /* Topbar (desktop): B2B-link + omskifter som eget element mellem USP'erne og højre side.
       (Ikke inde i ul.l4us – temaets USP-script ombryder og beskærer alle li'er der.) */
    var nt = d.getElementById('nav-top');
    if (nt && !nt.querySelector('.lp-vat')) {
      var box = el('<div class="lp-vat-li"><a class="lp-vat-b2b" href="' + (w.Shopify && w.Shopify.routes && w.Shopify.routes.root || '/') + 'pages/samarbejde">' + T.b2b + '</a></div>');
      box.appendChild(el(toggleHtml('lp-vat--top')));
      var right = nt.querySelector(':scope > ul[data-type="top-nav"]');
      if (right) nt.insertBefore(box, right); else nt.appendChild(box);
    }
    /* Mobilmenu: kompakt omskifter i menuens sorte top (temaets kopi af top-nav inde i #nav) */
    var mt = d.querySelector('#nav ul[data-type="top-nav"]');
    if (mt && !mt.querySelector('.lp-vat')) {
      var li = el('<li class="lp-vat-mli"><span class="lp-vat-ml" aria-hidden="true">' + T.vat + '</span>' +
        '<span class="lp-vat lp-vat--menu" role="group" aria-label="' + T.aria + '">' +
        '<button type="button" class="lp-vat__b" data-v="inc" aria-label="' + T.inc + '">' + T.incS + '</button>' +
        '<button type="button" class="lp-vat__b" data-v="ex" aria-label="' + T.ex + '">' + T.exS + '</button></span></li>');
      mt.insertBefore(li, mt.firstChild);
      paintButtons();
    }
    /* Kollektioner: lille tekstknap ved produktantallet */
    var hx = d.querySelector('form.f8sr fieldset span.hx');
    if (hx && !hx.parentNode.querySelector('.lp-vat-mini')) {
      var m = el('<button type="button" class="lp-vat-mini" data-v="toggle"><span class="lp-vat-tag">' + T.tagInc + '</span> · ' + T.swap + '</button>');
      hx.insertAdjacentElement('afterend', m);
    }
    /* Produktside: "Inkl. moms"-mærkatet bliver klikbart */
    d.querySelectorAll('.m6pr small.lp-tax').forEach(function (s) {
      if (s.__lpBound) return; s.__lpBound = true;
      s.setAttribute('role', 'button'); s.setAttribute('tabindex', '0'); s.setAttribute('title', T.title); s.classList.add('lp-vat-tax');
      var h = function (e) { if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return; e.preventDefault(); set(state() === 'ex' ? 'inc' : 'ex'); };
      s.addEventListener('click', h); s.addEventListener('keydown', h);
    });
  }
  d.addEventListener('click', function (e) {
    var b = e.target.closest('.lp-vat__b, .lp-vat-strip__b, .lp-vat-mini'); if (!b) return;
    var v = b.getAttribute('data-v'); if (v === 'toggle') v = state() === 'ex' ? 'inc' : 'ex';
    set(v);
  });
  function init() {
    if (CUR !== 'DKK') return; /* kun i DKK – i andre valutaer vises "kr" ikke, og omregningen ville ikke virke */
    mountUI();
    if (state() === 'ex') applyEx();
    paint();
    if ('MutationObserver' in w) {
      var t = null;
      new MutationObserver(function () {
        if (t) return;
        t = setTimeout(function () { t = null; mountUI(); if (state() === 'ex') applyEx(); }, 60);
      }).observe(d.body, { childList: true, subtree: true, characterData: true });
    }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})(window, document);
